import {FC} from 'react'

type Props = {
  role?: string
}

const UserLastLoginCell: FC<Props> = ({role}) => (
  <div className='badge badge-light fw-bolder'>{role ? 'Active' : 'Inactive'}</div>
)

export {UserLastLoginCell}
